/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useRef, useState} from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import {
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
  CardsWidget7,
  CardsWidget17,
  CardsWidget20,
  ListsWidget26,
  EngageWidget10,
  ListsWidget5,
} from '../../../_metronic/partials/widgets'
import * as Yup from 'yup'
import LeadServiceAPI from '../../../api/LeadServiceAPI'
import {ListsWidgetNew} from '../../../_metronic/partials/widgets/lists/ListsWidgetNew'
import Swal from 'sweetalert2'
import {toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {ToastContainer} from 'react-bootstrap'
import {TodoList} from '../../../_metronic/partials/widgets/lists/Todo'
import ReactDatePicker from 'react-datepicker'
interface FormValues {
  fullName: string
  phoneNumber: string
  birthday: string
  leadOwner: string
  email: string
  companyName: string
  anniversary: string
  leadStatus: string
}
const DashboardPage: FC = () => (
  <>
    {/* begin::Row */}
    <div className='row g-5 g-xl-10 mb-5 mb-xl-5'>
      {/* begin::Col */}
      <div className='col-lg-6 row' style={{paddingTop: 35}}>
        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-6 ct'>
          <CardsWidget20
            className='h-md-50 mb-5 mb-xl-10'
            description='Total Contacts'
            color='#F1416C'
            img={toAbsoluteUrl('/media/patterns/vector-1.png')}
          />
          <CardsWidget7
            className='h-md-45'
            description='Sent SMS'
            icon={false}
            stats={'10/100'}
            labelColor='#7E7E7E'
            textColor='gray-300'
          />
        </div>
        {/* end::Col */}
        {/* begin::Col */}
        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-6  ct'>
          <CardsWidget7
            className='h-md-45 mb-5 mb-xl-10'
            description='Active Leads'
            icon={false}
            stats={'20'}
            labelColor='#7E7E7E'
            textColor='gray-300'
          />
          <CardsWidget7
            className='h-md-45'
            description='Sent Emails'
            icon={false}
            stats={'40/100'}
            labelColor='dark'
            textColor='gray-300'
          />
        </div>
        {/* end::Col */}
        <div className='col-12'>
          <MixedWidget8 className='card-xxl-stretch' chartColor='success' chartHeight='150px' />
        </div>
      </div>

      {/* begin::Col */}
      <div className='col-xxl-6'>
        <ListsWidget3 className='card-xxl-stretch mb-xl-3' />
      </div>
      {/* end::Col */}
    </div>
    {/* end::Row */}

    {/* begin::Row */}

    {/* end::Row */}

    {/* begin::Row */}
    <div className='row gy-5 gx-xl-8'>
      {/* <div className='col-xxl-6'>
        <MixedWidget8
          className='card-xxl-stretch mb-xl-3'
          chartColor='success'
          chartHeight='250px'
        />{' '}
      </div> */}
      {/* <div className='col-xl-6'>
        <TablesWidget10 className='card-xxl-stretch mb-5 mb-xl-8' />
      </div> */}
    </div>
    {/* end::Row */}

    {/* begin::Row */}
    <div className='row gy-5 g-xl-8'>
      <div className='col-xl-6'>
        <ListsWidgetNew className='card-xxl-stretch mb-xl-3' />
      </div>
      {/* <div className='col-xl-4'>
        <ListsWidget6 className='card-xl-stretch mb-xl-8' />
      </div> */}
      <div className='col-xl-6'>
        <ListsWidget4 className='card-xl-stretch mb-5 mb-xl-8' items={5} />
        {/* partials/widgets/lists/_widget-4', 'class' => 'card-xl-stretch mb-5 mb-xl-8', 'items' => '5' */}
      </div>
    </div>
    {/* end::Row */}

    <div className='row g-5 gx-xxl-8'>
      <div className='col-xxl-6'>
        <TodoList className='card-xxl-stretch mb-xl-3' />
      </div>
      {/* <div className='col-xxl-8'>
        <TablesWidget5 className='card-xxl-stretch mb-5 mb-xxl-8' />
      </div> */}
    </div>
  </>
)

const validationSchema = Yup.object().shape({
  fullName: Yup.string().required('Full Name is required'),
  phoneNumber: Yup.string().required('Phone Number is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
})

const DashboardWrapper: FC<any> = () => {
  const intl = useIntl()
  const [showLeadPopup, setLeadPoppup] = useState<boolean>(false)
  const [uploadStatus, setUploadStatus] = useState<boolean>(false)
  const [contactStatus, setContactStatus] = useState<boolean>(false)
  const [contactStatusCompany, setContactStatusCompany] = useState<boolean>(false)
  const [stateLead, setStateLead] = useState<number>(1)

  const [currentState, setCurrentState] = useState<'individual' | 'company'>('individual')
  const [imgPath, setImgPath] = useState<any>('')

  const [fullName, setFullName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [birthday, setBirthday] = useState<any>('')
  const [leadOwner, setLeadOwner] = useState('')
  const [email, setEmail] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [anniversary, setAnniversary] = useState<any>('')
  const [leadStatus, setLeadStatus] = useState('')
  const [birthdayDay, setBirthdayDay] = useState(0)
  const [birthdayMonth, setBirthdayMonth] = useState(0)
  const [anniversaryDay, setAnniversaryDay] = useState(0)
  const [anniversaryMonth, setAnniversaryMonth] = useState(0)
  const [errors, setErrors] = useState<any>({})
  const [leadStatusList, setLeadStatusList] = useState<any>([])
  const [leadOwnerList, setLeadOwnerList] = useState<any>([])

  const [companyName2, setCompanyName2] = useState('')
  const [phoneNumberCompany, setPhoneNumberCompany] = useState('')
  const [leadOwnerCompany, setLeadOwnerCompany] = useState('')
  const [emailCompany, setEmailCompany] = useState('')
  const [officialAddressCompany, setOfficialAddressCompany] = useState('')
  const [leadStatusCompany, setLeadStatusCompany] = useState('')
  // const [formErrors, setFormErrors] = useState<any>({
  //   birthday: '',
  //   anniversary: '',
  //   leadStatus: '',
  //   leadOwner: '',
  //   fullName: '',
  //   email: '',
  //   phoneNumber: '',
  //   companyName: '',
  // })

  // const clearFormError = () => {
  //   setFormErrors({
  //     birthday: '',
  //     anniversary: '',
  //     leadStatus: '',
  //     leadOwner: '',
  //     fullName: '',
  //     email: '',
  //     phoneNumber: '',
  //     companyName: '',
  //   })
  // }

  const handleDateChange = (date: any) => {
    setBirthday(date)
    const dateObject = date
    const day = dateObject.getDate() // Get the day (1-31)
    const month = dateObject.getMonth() + 1 // Get the month (0-11). Adding 1 because months are zero-based.
    const year = dateObject.getFullYear() // Get the four-digit year

    setBirthdayDay(day)
    setBirthdayMonth(month)

    // // Perform validation for full name (e.g., check if it's not empty)
    // if (month.trim() === '') {
    //   setFormErrors((prevState: any) => ({...prevState, birthday: 'Birthday is required'}))
    // } else {
    //   setFormErrors((prevState: any) => ({...prevState, birthday: ''}))
    // }
  }
  const handleAnniversaryChange = (e: any) => {
    setAnniversary(e)
    const dateObject = new Date(e)
    const day = dateObject.getDate() // Get the day (1-31)
    const month = dateObject.getMonth() + 1 // Get the month (0-11). Adding 1 because months are zero-based.
    const year = dateObject.getFullYear() // Get the four-digit year

    setAnniversaryDay(day)
    setAnniversaryMonth(month)

    // if (!day) {
    //   setFormErrors((prevState: any) => ({...prevState, anniversary: 'Anniversary is required'}))
    // } else {
    //   setFormErrors((prevState: any) => ({...prevState, anniversary: ''}))
    // }
  }
  const handleFullNameChange = (e: any) => {
    setFullName(e.target.value)
    // if (e.target.value.trim() === '') {
    //   setFormErrors((prevState: any) => ({...prevState, fullName: 'Full Name is required'}))
    // } else {
    //   setFormErrors((prevState: any) => ({...prevState, fullName: ''}))
    // }
  }

  const handlePhoneNumberChange = (e: any) => {
    setPhoneNumber(e.target.value)
    // if (e.target.value.trim() === '') {
    //   setFormErrors((prevState: any) => ({...prevState, phoneNumber: 'Phone Number is required'}))
    // } else {
    //   setFormErrors((prevState: any) => ({...prevState, phoneNumber: ''}))
    // }
  }

  const handleLeadOwnerChange = (e: any) => {
    setLeadOwner(e.target.value)
    // if (e.target.value.trim() === '') {
    //   setFormErrors((prevState: any) => ({...prevState, leadOwner: 'lead Owner is required'}))
    // } else {
    //   setFormErrors((prevState: any) => ({...prevState, leadOwner: ''}))
    // }
  }

  const handleEmailChange = (e: any) => {
    setEmail(e.target.value)
    // if (e.target.value.trim() === '') {
    //   setFormErrors((prevState: any) => ({...prevState, email: 'Email is required'}))
    // } else {
    //   setFormErrors((prevState: any) => ({...prevState, email: ''}))
    // }
  }

  const handleCompanyNameChange = (e: any) => {
    setCompanyName(e.target.value)
    // if (e.target.value.trim() === '') {
    //   setFormErrors((prevState: any) => ({...prevState, companyName: 'Company Name is required'}))
    // } else {
    //   setFormErrors((prevState: any) => ({...prevState, companyName: ''}))
    // }
  }

  const handleLeadStatusChange = (e: any) => {
    setLeadStatus(e.target.value)
    // if (e.target.value.trim() === '') {
    //   setFormErrors((prevState: any) => ({...prevState, leadStatus: 'Lead Status is required'}))
    // } else {
    //   setFormErrors((prevState: any) => ({...prevState, leadStatus: ''}))
    // }
  }
  const clearFields = () => {
    // Reset the form after submission
    setFullName('')
    setPhoneNumber('')
    setBirthday('')
    setBirthdayDay(0)
    setBirthdayMonth(0)
    setLeadOwner('')
    setEmail('')
    setCompanyName('')
    setAnniversary('')
    setAnniversaryDay(0)
    setAnniversaryMonth(0)
    setLeadStatus('')
    setErrors({})
    setSelectedImage(null)

    setCompanyName2('')
    setPhoneNumberCompany('')
    setLeadOwnerCompany('')
    setEmailCompany('')
    setOfficialAddressCompany('')
    setLeadStatusCompany('')
  }

  // Handle Submit Lead Form
  const handleFormSubmit = (e:any) => {
    e?.preventDefault()

    let formData = new FormData()
    formData.append('lead_type', currentState === 'individual' ? '1' : '2')
    formData.append('lead_owner_id', leadOwner)
    formData.append('lead_status_id', leadStatus)
    formData.append('name', fullName)
    formData.append('email', email)
    formData.append('phone', phoneNumber)
    formData.append('company_name', companyName)
    formData.append('birthday', birthday)
    if (anniversaryDay > 0) {
      formData.append('anniversary_day', anniversaryDay?.toString())
      formData.append('anniversary_month', anniversaryMonth?.toString())
    }
    if (birthdayMonth > 0) {
      formData.append('birthday_month', birthdayMonth?.toString())
      formData.append('birthday_day', birthdayDay?.toString())
    }
    if (selectedImage) {
      formData.append('image', selectedImage)
    }
    // API Call
    LeadServiceAPI.createLead(formData).then(
      (res: any) => {
        if (res?.data?.success) {
          clearFields()
          toast.success(res?.data?.message, {theme: 'dark'})
          setCurrentState('individual')
          setLeadPoppup(false)
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        if (err.response && err.response.status === 400) {
          toast.error(err.response.data.message || 'API request error: Bad Request')
        } else {
          toast.error(err?.response?.data?.message || 'Failed response', {theme: 'dark'})
        }
      }
    )
  }

  const [selectedImage, setSelectedImage] = useState<File | null | any>(null)
  const [selectedImageCompany, setSelectedImageCompany] = useState<File | null | any>(null)

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedImage(event.target.files[0])
    }
  }
  const handleImageUploadCompany = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedImageCompany(event.target.files[0])
    }
  }
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const fileInputRefCompany = useRef<HTMLInputElement | null>(null)
  const handleClearImage = () => {
    setSelectedImage(null)
  }
  const handleClearImageCompany = () => {
    setSelectedImageCompany(null)
  }
  // handle popup
  const handlePopup = () => {
    setLeadPoppup(!showLeadPopup)
    setUploadStatus(false)
    setContactStatus(false)
  }

  // handle upload
  const handleUploadBtnAction = () => {
    setUploadStatus(true)
  }

  const handleCreateContact = (param: string) => {
    if (param === 'individual') {
      setUploadStatus(false)
      setContactStatusCompany(false)

      setContactStatus(true)
    } else {
      setUploadStatus(false)
      setContactStatus(false)

      setContactStatusCompany(true)
    }
  }

  // init
  useEffect(() => {
    if (stateLead === 1) {
      setStateLead(stateLead)
      handleCreateContact('individual')
    } else if (stateLead === 2) {
      setStateLead(stateLead)
      handleCreateContact('company')
    } else {
      setStateLead(stateLead)
      // console.log('first')
    }
  }, [stateLead])

  useEffect(() => {
    getLeads()
    getLeadOwners()
  }, [])

  // lead status
  const getLeads = () => {
    LeadServiceAPI.getLeadStatus().then(
      (res: any) => {
        if (res?.data?.success) {
          setLeadStatusList(res?.data?.data)
        } else {
          setLeadStatusList([])
        }
      },
      (err: any) => {
        setLeadStatusList([])
      }
    )
  }

  // lead owner list
  const getLeadOwners = () => {
    LeadServiceAPI.getLeadOwnerList().then(
      (res: any) => {
        if (res?.data?.success) {
          setLeadOwnerList(res?.data?.data)
        } else {
          setLeadOwnerList([])
        }
      },
      (err: any) => {
        setLeadOwnerList([])
      }
    )
  }

  const validateForm = () => {
    let isValid = true
    const errors: any = {}

    if (!companyName2.trim()) {
      errors.companyName2 = 'Company name is required.'
      isValid = false
    }

    if (!phoneNumberCompany.trim()) {
      errors.phoneNumberCompany = 'Phone number is required.'
      isValid = false
    }

    if (!leadOwnerCompany) {
      errors.leadOwnerCompany = 'Lead owner is required.'
      isValid = false
    }

    if (!emailCompany.trim()) {
      errors.emailCompany = 'Email is required.'
      isValid = false
    }

    if (!officialAddressCompany.trim()) {
      errors.officialAddressCompany = 'Official address is required.'
      isValid = false
    }

    if (!leadStatusCompany) {
      errors.leadStatusCompany = 'Lead status is required.'
      isValid = false
    }

    setErrors(errors)
    return isValid
  }

  // handleCompanyFormSubmit
  const handleCompanyFormSubmit = (e:any) => {
    e?.preventDefault()
    // Perform form submission or API call here
    let formData = new FormData()
    formData.append('lead_type', currentState === 'individual' ? '1' : '2')
    formData.append('lead_owner_id', leadOwnerCompany)
    formData.append('lead_status_id', leadStatusCompany)
    formData.append('email', emailCompany)
    formData.append('official_address', officialAddressCompany)
    formData.append('phone', phoneNumberCompany)
    formData.append('company_name', companyName2)

    if (selectedImageCompany) {
      formData.append('image', selectedImageCompany)
    }
    // API Call
    LeadServiceAPI.createLead(formData).then(
      (res: any) => {
        if (res?.data?.success) {
          // Reset form fields
          setCompanyName2('')
          setPhoneNumberCompany('')
          setLeadOwnerCompany('')
          setEmailCompany('')
          setOfficialAddressCompany('')
          setLeadStatusCompany('')

          toast.success(res?.data?.message, {theme: 'dark'})
          setCurrentState('individual')
          setLeadPoppup(false)
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        if (err.response && err.response.status === 400) {
          toast.error(err.response.data.message || 'API request error: Bad Request')
        } else {
          toast.error(err?.response?.data?.message || 'Failed response', {theme: 'dark'})
        }
      }
    )
    // } else {
    //   console.log(errors)
    // }
  }
  const handleFileUpload = (event: any) => {
    const file = event.target.files[0]
    if (event.target.files[0]) {
      let formData = new FormData()
      formData.append('lead_file', file)
      LeadServiceAPI.downloadLead(formData).then(
        (res: any) => {
          if (res?.data?.success) {
            toast.success(res?.data?.message, {theme: 'dark'})
            clearFields()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          toast.error(err?.response?.data?.message, {theme: 'dark'})
        }
      )
    }
  }
  // render
  return (
    <>
      <ToastContainer />

      <div className='col-12 text-end mb-2 px-5'>
        <button
          type='button'
          className='btn btn-primary btn-sm'
          onClick={handlePopup}
          style={{borderRadius: 45}}
        >
          + New Lead
        </button>
      </div>
      {showLeadPopup && (
        <div
          className='modal fade show'
          tabIndex={-1}
          role='dialog'
          style={{
            display: showLeadPopup ? 'flex' : 'none',
            alignItems: 'center',
            backdropFilter: 'contrast(0.4)',
            overflow: 'hidden',
          }}
        >
          <div className='modal-dialog  modal-lg' role='document'>
            <div className='modal-content'>
              <div className='modal-header'>
                <div className='flex-grow-1'>
                  <h5 className='modal-title'>Add New Lead</h5>
                </div>
                <div className='flex-grow-0 d-flex'>
                  {uploadStatus === false && contactStatus === true && (
                    <div className='nav-group nav-group-outline mx-auto' data-kt-buttons='true'>
                      <a
                        href='#'
                        className={
                          'btn btn-color-gray-400 btn-active btn-active-secondary px-6 py-3 me-2 ' +
                          (currentState === 'individual' && 'active')
                        }
                        onClick={() => {
                          setCurrentState('individual')
                        }}
                        data-kt-plan='individual'
                      >
                        Individual
                      </a>
                      <a
                        href='#'
                        className={
                          'btn btn-color-gray-400 btn-active btn-active-secondary px-6 py-3 me-2 ' +
                          (currentState === 'company' && 'active')
                        }
                        onClick={() => {
                          setCurrentState('company')
                        }}
                        data-kt-plan='company'
                      >
                        Company
                      </a>
                    </div>
                  )}
                  <button
                    type='button'
                    className='btn btn-sm close'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={handlePopup}
                  >
                    <i className='fa fa-close' style={{fontSize: '2rem'}}></i>
                  </button>
                </div>
              </div>
              <div
                className={`${
                  contactStatus === false && 'py-12'
                } modal-body d-flex justify-content-center`}
              >
                <div className='col-lg-10 d-flex flex-column'>
                  {/* default body */}
                  {uploadStatus === false && contactStatus === false && (
                    <div className='row align-items-center'>
                      <div
                        className='col-lg-6  d-flex flex-wrap justify-content-center'
                        style={{border: '1px dashed #989898', padding: '50px 34px'}}
                      >
                        <img src={toAbsoluteUrl('/media/icons/folder.png')} alt='upload' />
                        <p style={{textAlign: 'center'}}>
                          CSV files can be uploaded to Asterics CRM.{' '}
                          <span style={{color: 'green'}}>Get your document ready</span>
                        </p>
                        <button
                          type='button'
                          className='btn btn-dark'
                          style={{padding: '5px 30px'}}
                          onClick={handleUploadBtnAction}
                        >
                          Upload
                        </button>
                      </div>
                      <div className='col-lg-1  d-flex flex-wrap justify-content-center'>Or</div>

                      <div
                        className='col-lg-5  d-flex flex-wrap justify-content-center'
                        style={{border: '1px dashed #989898', padding: '35px 20px'}}
                      >
                        <img src={toAbsoluteUrl('/media/icons/profile.png')} alt='upload' />
                        <p style={{textAlign: 'center'}}>
                          You can manually type the contact details you’ll like to add to the CRM.
                        </p>
                        <button
                          type='button'
                          className='btn btn-dark'
                          style={{padding: '5px 30px'}}
                          onClick={() => handleCreateContact('individual')}
                        >
                          Add Contact
                        </button>
                      </div>
                    </div>
                  )}

                  {/* if upload status true */}
                  {uploadStatus === true && contactStatus === false && (
                    <div className='row align-items-center'>
                      <div
                        className='col-lg-12 d-flex flex-wrap justify-content-center'
                        style={{border: '1px dotted #989898', padding: '50px 0', borderRadius: 15}}
                      >
                        <img src={toAbsoluteUrl('/media/icons/csv.png')} alt='upload' />
                        <p style={{textAlign: 'center'}} className='w-100 mt-2'>
                          <span style={{color: '#1280E0', fontSize: 18}}>
                            {' '}
                            Select a CSV file to upload
                          </span>{' '}
                          <br />
                          or drag and drop it here
                        </p>
                        <input
                          type='file'
                          accept='.xlsx'
                          onChange={handleFileUpload}
                          style={{display: 'none'}}
                          id='file-upload-input'
                        />
                        <label
                          htmlFor='file-upload-input'
                          className='btn btn-light text-dark'
                          style={{
                            padding: '5px 50px',
                            color: '#000',
                            fontWeight: 500,
                            fontSize: 15,
                          }}
                        >
                          Upload
                        </label>
                      </div>
                    </div>
                  )}

                  {/* if contact status => true */}
                  {contactStatus === true &&
                    (currentState === 'individual' ? (
                      <form onSubmit={handleFormSubmit}>
                        <div className='row align-items-center mb-5'>
                          <div className='col-lg-12 d-flex flex-wrap justify-content-center mb-5'>
                            <div className='form-group d-flex flex-wrap justify-content-center'>
                              <label className='w-100 text-center'>Profile Photo</label>
                              <div className='d-flex flex-wrap'>
                                <input
                                  type='file'
                                  accept='image/*'
                                  style={{display: 'none'}}
                                  onChange={handleImageUpload}
                                  ref={fileInputRef}
                                />
                                {selectedImage === null ? (
                                  <button
                                    className='bg-light px-5 py-4'
                                    style={{border: 'none', borderRadius: '50%'}}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      if (fileInputRef.current) {
                                        fileInputRef.current.click()
                                      }
                                    }}
                                  >
                                    <i className='fa fa-plus'></i>
                                  </button>
                                ) : (
                                  <div className='selected-image-container w-100'>
                                    <img
                                      className='selected-image'
                                      src={selectedImage ? URL.createObjectURL(selectedImage) : ''}
                                      alt='Selected'
                                      height={40}
                                    />
                                    <br />
                                    <button
                                      className='remove-image-button m-3'
                                      style={{
                                        background: '#f3f3f3',
                                        borderRadius: 10,
                                        color: 'red',
                                      }}
                                      onClick={handleClearImage}
                                    >
                                      x
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                            {/* Display the selected image */}
                          </div>
                          <div className='col-lg-6'>
                            <div className='form-group mb-3'>
                              <label>Full Name</label>
                              <input
                                type='text'
                                required
                                className='form-control'
                                placeholder='Enter contacts full name'
                                value={fullName}
                                onChange={handleFullNameChange}
                              />
                              {/* {formErrors.fullName && (
                                <p className='text-danger'>{formErrors.fullName}</p>
                              )} */}
                            </div>
                            <div className='form-group mb-3'>
                              <label>Phone Number</label>
                              <input
                                required
                                type='text'
                                className='form-control'
                                placeholder='Enter contacts Phone '
                                value={phoneNumber}
                                onChange={handlePhoneNumberChange}
                              />
                              {/* {formErrors.phoneNumber && (
                                <p className='text-danger'>{formErrors.phoneNumber}</p>
                              )} */}
                            </div>
                            <div className='form-group mb-3'>
                              <label>Birthday(optional)</label>
                              <ReactDatePicker
                                className='form-control'
                                selected={birthday}
                                onChange={handleDateChange}
                                dateFormat='dd/MM'
                                placeholderText='Select Birth Day'
                                showYearDropdown={false}
                                scrollableYearDropdown
                              />
                            </div>
                            <div className='form-group mb-3'>
                              <label>Lead Owner</label>
                              <select
                                required
                                className='form-control form-select'
                                value={leadOwner}
                                disabled={leadOwnerList?.length === 0}
                                onChange={handleLeadOwnerChange}
                              >
                                <option value={''} selected>
                                  Select Lead Owner
                                </option>
                                {leadOwnerList?.map((e: any, index: number) => (
                                  <option value={e?.userDetails?.id} key={index}>
                                    {e?.name}
                                  </option>
                                ))}
                              </select>
                              {/* {formErrors.leadOwner && (
                                <p className='text-danger'>{formErrors.leadOwner}</p>
                              )} */}
                            </div>
                          </div>

                          <div className='col-lg-6'>
                            <div className='form-group mb-3'>
                              <label>Email</label>
                              <input
                                required
                                type='text'
                                className='form-control'
                                placeholder='Enter contacts email'
                                value={email}
                                onChange={handleEmailChange}
                              />
                              {/* {formErrors.email && (
                                <p className='text-danger'>{formErrors.email}</p>
                              )} */}
                            </div>
                            <div className='form-group mb-3'>
                              <label>Company Name (optional)</label>
                              <input
                                type='text'
                                className='form-control'
                                placeholder='Enter contacts company name '
                                value={companyName}
                                onChange={handleCompanyNameChange}
                              />
                            </div>
                            <div className='form-group mb-3'>
                              <label>Anniversary (optional) </label>
                              <ReactDatePicker
                                className='form-control'
                                selected={anniversary}
                                onChange={handleAnniversaryChange}
                                dateFormat='dd/MM'
                                placeholderText='Select Anniversary Day'
                                showYearDropdown={false}
                                scrollableYearDropdown
                              />
                            </div>
                            <div className='form-group mb-3'>
                              <label>Lead Status</label>
                              <select
                                required
                                className='form-control form-select'
                                value={leadStatus}
                                onChange={handleLeadStatusChange}
                                disabled={leadStatusList?.length === 0}
                              >
                                <option value='' selected>
                                  Select Lead Status
                                </option>
                                {leadStatusList?.map((e: any, index: number) => (
                                  <option value={e?.id} key={index}>
                                    {e?.title}
                                  </option>
                                ))}
                              </select>
                              {/* {formErrors.leadStatus && (
                                <p className='text-danger'>{formErrors.leadStatus}</p>
                              )} */}
                            </div>
                          </div>
                          <div className='col-lg-12 d-flex justify-content-between mt-3'>
                            <button
                              type='button'
                              className='btn btn-light'
                              style={{padding: '10px 30px', borderRadius: 20}}
                            >
                              Cancel
                            </button>
                            <button
                              type='submit'
                              className='btn btn-dark'
                              style={{padding: '10px 30px', borderRadius: 20}}
                              // onClick={handleFormSubmit}
                            >
                              Create Lead
                            </button>
                          </div>
                        </div>
                      </form>
                    ) : (
                      <form onSubmit={handleCompanyFormSubmit}>
                        <div className='row align-items-center mb-5'>
                          <div className='col-lg-12 d-flex flex-wrap justify-content-center mb-5'>
                            <div className='form-group d-flex flex-wrap justify-content-center'>
                              <label className='w-100 text-center'>Profile Photo</label>
                              <div className='d-flex flex-wrap'>
                                <input
                                  type='file'
                                  accept='image/*'
                                  style={{display: 'none'}}
                                  onChange={handleImageUploadCompany}
                                  ref={fileInputRefCompany}
                                />
                                {selectedImageCompany === null ? (
                                  <button
                                    className='bg-light px-5 py-4'
                                    style={{border: 'none', borderRadius: '50%'}}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      if (fileInputRefCompany.current) {
                                        fileInputRefCompany.current.click()
                                      }
                                    }}
                                  >
                                    <i className='fa fa-plus'></i>
                                  </button>
                                ) : (
                                  <div className='selected-image-container w-100'>
                                    <img
                                      className='selected-image'
                                      src={
                                        selectedImageCompany
                                          ? URL.createObjectURL(selectedImageCompany)
                                          : ''
                                      }
                                      alt='Selected'
                                      height={40}
                                    />
                                    <br />
                                    <button
                                      className='remove-image-button m-3'
                                      style={{
                                        background: '#f3f3f3',
                                        borderRadius: 10,
                                        color: 'red',
                                      }}
                                      onClick={handleClearImageCompany}
                                    >
                                      x
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                            {/* Display the selected image */}
                          </div>
                          <div className='col-lg-6'>
                            <div className='form-gorup mb-3'>
                              <label>Company Name</label>
                              <input required
                                type='text'
                                minLength={5}
                                className='form-control'
                                value={companyName2}
                                onChange={(e) => setCompanyName2(e?.target?.value)}
                                placeholder='Enter Company Name'
                              />
                            </div>
                            <div className='form-gorup mb-3'>
                              <label>Phone Number</label>
                              <input required
                                type='text'
                                className='form-control'
                                placeholder='Enter contacts Phone '
                                value={phoneNumberCompany}
                                onChange={(e) => setPhoneNumberCompany(e?.target?.value)}
                              />
                            </div>

                            <div className='form-gorup mb-3'>
                              <label>Lead Owner</label>
                              <select required
                                className='form-control form-select'
                                value={leadOwnerCompany}
                                disabled={leadOwnerList?.length === 0}
                                onChange={(e) => setLeadOwnerCompany(e?.target?.value)}
                              >
                                <option value={''} selected>Select Lead Owner</option>
                                {leadOwnerList?.map((e: any, index: number) => (
                                  <option value={e?.userDetails?.id} key={index}>
                                    {e?.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div className='col-lg-6'>
                            <div className='form-gorup mb-3'>
                              <label>Official Email</label>
                              <input required
                                type='email'
                                className='form-control'
                                placeholder='Enter contacts email'
                                value={emailCompany}
                                onChange={(e) => setEmailCompany(e?.target?.value)}
                              />
                            </div>
                            <div className='form-gorup mb-3'>
                              <label>Official Address</label>
                              <input required
                                type='text'
                                className='form-control'
                                placeholder='Enter Address '
                                value={officialAddressCompany}
                                onChange={(e) => setOfficialAddressCompany(e?.target?.value)}
                              />
                            </div>

                            <div className='form-gorup mb-3'>
                              <label>Lead Status</label>
                              <select required
                                className='form-control form-select'
                                value={leadStatusCompany}
                                onChange={(e) => setLeadStatusCompany(e?.target?.value)}
                                disabled={leadStatusList?.length === 0}
                              >
                                <option value={''} selected>Select Lead Status</option>
                                {leadStatusList?.map((e: any, index: number) => (
                                  <option value={e?.id} key={index}>
                                    {e?.title}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className='col-lg-12 d-flex justify-content-between mt-3'>
                            <button
                              type='button'
                              onClick={clearFields}
                              className='btn btn-light'
                              style={{padding: '10px 30px', borderRadius: 20}}
                            >
                              Cancel
                            </button>
                            <button
                              type='submit'
                              // onClick={handleCompanyFormSubmit}
                              className='btn btn-dark'
                              style={{padding: '10px 30px', borderRadius: 20}}
                            >
                              Create Lead
                            </button>
                          </div>
                        </div>
                      </form>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
